import { Component } from "react";
import { Button } from "@/components/ui/button";
import { Warning, ArrowClockwise } from "@phosphor-icons/react";
import { isChunkError, recoverFromChunkError } from "@/lib/lazyPage";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) { recoverFromChunkError(error); }
  componentDidUpdate(prev) { if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    const stale = isChunkError(this.state.error);
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="error-boundary">
        <div className="h-12 w-12 rounded-md bg-destructive/10 text-destructive flex items-center justify-center mb-4"><Warning size={24} weight="bold" /></div>
        <h2 className="text-lg font-bold">{stale ? "A new version of the app is available" : "Something went wrong on this page"}</h2>
        <p className="text-sm text-muted-foreground mt-1 max-w-md">{stale ? "The app was updated while this tab was open, so this page could not load. Reload to get the latest version — nothing is lost." : "The rest of the app is fine. You can retry, or go back and open another page."}</p>
        {!stale && <pre className="mt-3 max-w-xl overflow-auto rounded-md bg-muted px-3 py-2 text-left font-mono text-[11px] text-muted-foreground">{String(this.state.error?.message || this.state.error)}</pre>}
        <div className="mt-4 flex gap-2">
          {stale
            ? <Button onClick={() => window.location.reload()} data-testid="error-reload"><ArrowClockwise size={14} className="mr-1.5" /> Reload app</Button>
            : <>
              <Button onClick={() => this.setState({ error: null })} data-testid="error-retry"><ArrowClockwise size={14} className="mr-1.5" /> Retry</Button>
              <Button variant="outline" onClick={() => window.location.reload()} data-testid="error-reload">Reload app</Button>
            </>}
        </div>
      </div>
    );
  }
}
